import api from "api";
import { supportApiBase } from "api/constants";
import { InvitationRecord, InvitationsParams } from "api/invitationTypes";
import { PaginationMetadata } from "shared/SearchPagination";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";

export interface InvitationsPage {
  items: InvitationRecord[];
  metadata: { pagination: PaginationMetadata };
}

const useListInvitations = (params: InvitationsParams) => {
  const key = queryKeys.invitations(params);

  return useQuery(key, async (): Promise<InvitationsPage> => {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.set("status", params.status);
    if (params.source) queryParams.set("source", params.source);
    if (params.search) queryParams.set("search", params.search);
    if (params.therapist_id) queryParams.set("therapist_id", String(params.therapist_id));
    if (params.page) queryParams.set("page", String(params.page));
    if (params.limit) queryParams.set("limit", String(params.limit));

    const response = await api.call(`/invitations?${queryParams}`, { root: supportApiBase });
    const body = await response.json();

    return {
      items: (body?.items ?? []) as InvitationRecord[],
      metadata: { pagination: (body?.metadata ?? {}) as PaginationMetadata },
    };
  });
};

export default useListInvitations;
